export default __webpack_public_path__ + "static/media/Wall_Orange.256.9b9e409f.png";